import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import ar from "./locales/ar.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            fr: { translation: fr },
            ar: { translation: ar },
        },
        fallbackLng: "fr",
        interpolation: {
            escapeValue: false
        },
        // Missing-key safety (user improvement)
        returnNull: false,
        returnEmptyString: false,
        // Language detection config
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        }
    });

// RTL/LTR direction handling
i18n.on('languageChanged', (lng) => {
    document.documentElement.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lng);
});

export default i18n;
